import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { RequestForQuoteStatusEnum } from "@enums/requestForQuoteStatus.enum";
import { Model } from "@interfaces/model.interface";

export interface RequestForQuote extends Model {
	// Billet lines, for a quote raised from a tool rather than a sales order.
	billetLineItems?: string;
	createdById: number;
	dateSent: Date;
	lineItems: string;
	outsourcedLineItems: string;
	productionToolId?: number;
	projectManagerId?: number;
	purchaseType: PurchaseTypeEnum;
	salesOrderId?: number;
	status: RequestForQuoteStatusEnum;
	supplierId: number;
}

export class RequestForQuote implements RequestForQuote {
	constructor(data?: Partial<RequestForQuote>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}